import React from 'react';
import { Grid, Row, Col, Text } from 'rsuite';

const UpdateSuccessFields = () => {
  return (
    <Grid className="content-section">
      <Row>
        <Col xs={24}>
          <Grid
            fluid
            className="mb-24"
          >
            <Row>
              <Col xs={24}>
                <Text className="mv-8 text-bold">Success!</Text>
                <Text className="mv-8">
                  Your request to update information has been submitted
                  successfully.
                </Text>
              </Col>
            </Row>
          </Grid>
        </Col>
      </Row>
    </Grid>
  );
};

export default UpdateSuccessFields;
